/* import __COLOCATED_TEMPLATE__ from './goto.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();